import { Button, Form, Input, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { BrowserStorageUtil, cookieStorage } from '@swift-247/s247.library.ui-core';
import buildTimeConfig from '../../../config/buildtime.config';
import config from '../../../config/config';
import { redirectToBooking } from '../../utilities/webview';
import {
  forgotPasswordPINAction,
  requestGetProfile,
  requestLoginAction,
  resetStateAction,
  storeBizAccountCurrentPassword
} from '../../store/login/actions';
import {
  getCanForgot,
  getCustomerCode, getLoginErrorCode,
  getLoginMessage,
  getLoginStatus,
  getPhoneNumber,
  getUserProfile
} from '../../store/login/selectors';

const ValidatePassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [isDisabled, setIsDisabled] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const isLoggedIn = useSelector(getLoginStatus);
  const canForgot = useSelector(getCanForgot);
  const phoneNumber = useSelector(getPhoneNumber);
  const customerCode = useSelector(getCustomerCode);
  const loginErrorCode = useSelector(getLoginErrorCode);
  const userProfile = useSelector(getUserProfile);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const loginMessage = useSelector(getLoginMessage);
  const {t} = useTranslation();

  useEffect(() => {
    if (!!phoneNumber && !!customerCode) {
      navigate('/');
    }
    if (isLoggedIn) {
      const envStorage = buildTimeConfig.env !== 'local' ? localStorage : cookieStorage;
      const authInfo = new BrowserStorageUtil(envStorage as any).deserializedGet('authInfo');
      if (!authInfo?.accessToken) {
        dispatch(resetStateAction());
        navigate('/');
        return;
      }
      // check is biz account & redirect to create pw for 1st login
      if (customerCode && !userProfile) {
        dispatch(requestGetProfile());
      } else if (userProfile && userProfile.loginFirst) {
        navigate('/create-password');
      } else {
        redirectToBooking();
      }
    }
  }, [phoneNumber, isLoggedIn, userProfile, customerCode]);

  const handleForgotPassword = () => {
    if (customerCode) {
      setIsModalVisible(true);
    } else {
      dispatch(forgotPasswordPINAction(phoneNumber));
    }
  };

  const validateForm = () => {
    let isValid = true;
    const { password } = form.getFieldsValue();
    setErrorMessage('');

    if (!password || !password.length) {
      setErrorMessage('validation_required_password');
      isValid = false;
    } else if (password.slice(0, 1) === ' ' || password.slice(-1) === ' ') {
      setErrorMessage(
        'validation_spaces_password',
      );
      isValid = false;
    } else if (password.length < 6 || password.length > 20) {
      setErrorMessage('validation_range_length_password');
      isValid = false;
    }
    setIsDisabled(!isValid);
    return isValid;
  };

  useEffect(() => {
    if (canForgot) {
      navigate('/enter-otp');
    }
  }, [canForgot]);

  const onSubmit = () => {
    const { password } = form.getFieldsValue();
    if (validateForm()) {
      if (customerCode) {
        dispatch(requestLoginAction({ username: customerCode, password }));
        dispatch(storeBizAccountCurrentPassword({ password }));
      } else {
        dispatch(requestLoginAction({ username: phoneNumber, password }));
      }
    }
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <div className="header-title">
        <div className="title">{t('global_welcome')}</div>
        <div className="subtitle font-semi-bold">
          {t('section_title_login')}
        </div>
      </div>
      <Modal
        title={t('section_title_forgot_password')}
        visible={isModalVisible}
        footer={[<Button type="primary" onClick={closeModal}>{t('global_exit')}</Button>]}
      >
        <p>
          {t('business_account_message_forgot_password_1')} <a href="tel:1900272747">1900272747</a> {t('business_account_message_forgot_password_2')}
        </p>
      </Modal>
      <Form
        className="w-100"
        layout="vertical"
        form={form}
        onFinish={onSubmit}
        onValuesChange={() => validateForm()}
      >
        <Form.Item
          label={`${t('screen_validation_password_title')}, ${phoneNumber || customerCode || ""}`}
          help={t(errorMessage)}
          name="password"
        >
          <div>
            <Input.Password
              className={'mb-1'}
              placeholder={t('placeholder_enter_password')}
              autoFocus
            />
            <div className="forgot-password-btn font-medium">
              <span onClick={handleForgotPassword}>{t('screen_validation_password_forgot_password_message')}</span>
            </div>
            { (loginMessage || loginErrorCode === 'invalid_credentials') && (
              <div className="text-danger">
                {t(loginErrorCode === 'invalid_credentials' ? 'validation_wrong_authentication_info' : loginMessage)}
              </div>
            )}
          </div>
        </Form.Item>

        <Form.Item>
          <Button type='primary' htmlType="submit" disabled={isDisabled}>
            {t('button_login')}
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};
export default ValidatePassword;
